import React from 'react'
import styles from './context-menu.styles'
import injectSheet from 'react-jss'
import MoreButton from 'pobble-components/dist/more-button'
import DropMenu from 'pobble-components/dist/drop-menu'
import CopyIcon from 'react-icons/lib/fa/copy'
import ArchiveIcon from 'react-icons/lib/fa/trash'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'

const ContextMenu = ({ classes, onCopy, onArchive }) => (
  <DropMenu
    button={({ ref, togglePopover }) => (
      <MoreButton forwardedRef={ref} onClick={togglePopover} />
    )}>
    {({ Menu, MenuItem, IconHolder, Separator, closePopover }) => (
      <Menu>
        <MenuItem
          onClick={() => {
            closePopover()
            onCopy()
          }}>
          <IconHolder>
            <CopyIcon />
          </IconHolder>
          Copy
        </MenuItem>
        <MenuItem
          onClick={() => {
            openConfirmationDialog({
              bodyText:
                'Are you sure you want to archive this moderation file?',
              action: () => onArchive(),
              confirmText: 'Archive',
              cancelText: 'Cancel'
            })
            closePopover()
          }}>
          <IconHolder>
            <ArchiveIcon />
          </IconHolder>
          Archive
        </MenuItem>
      </Menu>
    )}
  </DropMenu>
)

export default injectSheet(styles)(ContextMenu)
